<template>
  <div class="pay"></div>
</template>

<script>
import {Popup, Toast} from "vant";

export default {
  name: "pay",
  components: {
    [Toast.name]: Toast,
  },
  data() {
    return {

    }
  },
  created:function(){

  },
  methods: {

  }
}
</script>

<style scoped>

</style>
